import React from 'react'
import styled from 'styled-components'

import { TitleRow } from './title-row'
import { InputRow } from './input-row'

export const TabPaneLicensing = props => {
  const { licenses, handleInput } = props

  return (
    <Root>
      <TitleRow />
      <RowWrapper>
        {licenses.map((license, key) => (
          <InputRow
            idx={ key.toString() }
            key={ key }
            license={ license }
            handleInput={ handleInput }
          />
        ))}
      </RowWrapper>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

const RowWrapper = styled.div`
  height: 100%;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/tab-pane-licensing/index.js